import { render, staticRenderFns } from "./GfLoanApplicationList.vue?vue&type=template&id=023dcc04"
import script from "./GfLoanApplicationList.vue?vue&type=script&lang=js"
export * from "./GfLoanApplicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports